import { Tooltip } from 'antd'
import * as React from 'react'

export const ConditionalTooltip = (props: { title: string; condition: boolean; children }) =>
    props.condition ? <Tooltip title={props.title}>{props.children}</Tooltip> : <>{props.children}</>
